import { useMutation } from '@apollo/client';
import { Button, Modal, Tooltip } from 'antd';
import React, { useContext, useState } from 'react';
import { AppContext } from '../../../../../AppContext';
import { USER_ROLES } from '../../../../../common/constants';
import useInventoryUnitsFeature from '../../../../../hooks/useInventoryUnitsFeature';
import { SYNC_ORDER_ITEM_STAFF_ASSIGNMENT } from '../graphql/Mutations';

const AutoAssignInfo = () => (
  <div className="auto-assign-staff-info">
    <div>Assigns pickers and packers to orders in one click:</div>
    <ul>
      <li>
        <strong>Not assigned yet</strong> - gets a picker and packer from your
        available staff.
      </li>
      <li>
        <strong>Staff marked as not available</strong> - if you turned off
        availability of a picker or packer who already has orders, those orders
        are reassigned to another available picker or packer.
      </li>
      <li>
        <strong>Everything else stays the same</strong> - orders already
        assigned to an available picker or packer are not changed.
      </li>
    </ul>
  </div>
);

const AutoAssignStaffButton = ({
  className = 'common-button ml-16',
  onSuccess,
}) => {
  const {
    state: { currentUser },
  } = useContext(AppContext);
  const { isUnitsFeatureEnabled } = useInventoryUnitsFeature();
  const [isPromptOpen, setIsPromptOpen] = useState(false);

  const [
    syncOrderItemStaffAssignment,
    { loading },
  ] = useMutation(SYNC_ORDER_ITEM_STAFF_ASSIGNMENT, { onError() {} });

  const handleConfirm = async () => {
    const response = await syncOrderItemStaffAssignment({
      variables: {
        where: { libraryId: currentUser?.libraryId },
        data: { roles: [USER_ROLES?.PICKER?.key, USER_ROLES?.PACKER?.key] },
      },
    });
    if (response?.data) {
      setIsPromptOpen(false);
      onSuccess?.();
    }
  };

  if (!isUnitsFeatureEnabled) return null;

  return (
    <>
      <Tooltip title={<AutoAssignInfo />} placement="bottom">
        <Button
          className={className}
          size="middle"
          loading={loading}
          onClick={() => setIsPromptOpen(true)}
        >
          Auto Assign Picker / Packer
        </Button>
      </Tooltip>
      <Modal
        title="Auto Assign Picker / Packer"
        okText="Yes"
        cancelText="No"
        open={isPromptOpen}
        onOk={handleConfirm}
        onCancel={() => setIsPromptOpen(false)}
        okButtonProps={{ loading }}
      >
        <AutoAssignInfo />
        <div className="mt-8">Do you want to continue?</div>
      </Modal>
    </>
  );
};

export default AutoAssignStaffButton;
